import { Tablist } from './tablist.component';

export * from './tablist.component';
export default Tablist;

Tablist.define('der-ui-tablist');

declare global {
    interface HTMLElementTagNameMap {
        'der-ui-tablist': Tablist;
    }
}
